<content>
    <form [formGroup]="editForm" [ngClass]="{'show-error': showError}">
        <div class="info">{{ 'global.infoRequired' | translate}}</div>
        <div class="entry-3-modal">
          <label>{{'mantenimientoDesignaciones.table.fecha' | translate}} *</label>
          <input [matDatepicker]="fechaDesignacion" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaDesignacion"
              (click)="fechaDesignacion.open()">
          <mat-datepicker #fechaDesignacion></mat-datepicker>
        </div>
        <div class="entry-3-modal">
          <label>{{'global.cultivo' | translate}}</label>
          <input type="text" formControlName="cultivo">
        </div>
        <div class="entry-3-modal">
          <label>{{'mantenimientoDesignaciones.table.productor' | translate}}</label>
          <input type="text" formControlName="productor">
        </div>
        <div class="entry-3-modal">
            <label>{{'mantenimientoDesignaciones.table.cantidad' | translate}} *</label>
            <input type="number" formControlName="cantidad">
        </div>
        <div class="entry-3-modal" *ngIf="this.role === 'Administrador' || this.claims.includes('D_DSG_AforoVisible')">
            <label>{{'mantenimientoDesignaciones.table.aforo' | translate}}</label>
            <input type="number" formControlName="aforo">
        </div>
        <div class="entry-3-modal" *ngIf="this.role === 'Administrador' || this.claims.includes('D_DSG_AforoVisible')">
            <label>{{'mantenimientoDesignaciones.table.aforoDisponible' | translate}}
              ({{(this.editForm ? this.editForm.get('aforoDisponible').value : 0) | number : '1.2-2': defaultLanguage}}
              Kg)</label>
            <progress [ngClass]="{'exceeded': porcentajeAforoDisponible > 100 ||
              porcentajeAforoDisponible < 0}" [value]="porcentajeAforoDisponible" max="100"
              min="-1000"></progress><span>{{porcentajeAforoDisponible.toFixed(2) | number : '1.2-2': defaultLanguage}}%</span>
        </div>
        <div *ngIf="this.role === 'Administrador' || this.claims.includes('DSG_Upd_ImpAut')" class="entry-3-modal alignment-start">
          <input type="checkbox" id="impresionAutorizada" formControlName="impresionAutorizada">
          <label for="impresionAutorizada">{{'mantenimientoDesignaciones.table.impresion' | translate}}</label>
        </div>
        <div *ngIf="this.role === 'Administrador' || this.claims.includes('DSG_Upd_ReimpAut')" class="entry-3-modal alignment-start">
          <input type="checkbox" id="reimpresionAutorizada" formControlName="reimpresionAutorizada">
          <label for="reimpresionAutorizada">{{'mantenimientoDesignaciones.table.reimpresion' | translate}}</label>
        </div>
        <div *ngIf="this.role === 'Administrador' || this.claims.includes('DSG_Upd_Fin')" class="entry-3-modal alignment-start">
          <input type="checkbox" id="editFinalizada" formControlName="finalizada">
          <label for="editFinalizada">{{'mantenimientoDesignaciones.table.finalizada' | translate}}</label>
        </div>
        <div class="entry-3-modal alignment-start">
          <input type="checkbox" id="etiqueta-digital-edit-desig" formControlName="etiquetaDigital">
          <label for="etiqueta-digital-edit-desig">{{'global.etiquetaDigital' | translate}}</label>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="checkIfShowEtiquetaDigitalModal()">{{'global.actualizar' | translate}}</button>
</footer>

<div class="modal" *ngIf="etiquetaDigitalModal">
    <div class="modal-content" style="max-width: 30rem">
      <header>
        <h4>{{ 'global.etiquetaDigital' | translate }}</h4>
      </header>
      <content>
        <p [innerHTML]="'global.info.etiquetaDigital' | translate"></p>
      </content>
      <footer>
        <button class="secondary" (click)="etiquetaDigitalModal = false">{{'global.cancelar' | translate}}</button>
        <button (click)="save()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
</div>
<app-toast *ngIf="mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
